//region :: Imports ::
import {ReactElement, ReactNode} from 'react';
import {Field, FieldProps} from 'formik';
import {classNames} from 'primereact/utils';
import MComponent from '../Component';
import MErrorText from './ErrorText';
import {MFormControlBaseProps} from './FormControl';
import MHelpIcon from './HelpIcon';

//endregion

/** */
type Props = MFormControlBaseProps & {
    fieldName: string;
    children: (fieldProps: FieldProps, fieldClasses: string | undefined) => ReactNode;
}

/** */
class MFormFieldControl extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        const icon = this.props.icon === undefined ? '' : `pi ${this.props.icon}`;
        const iconPosition = icon === '' ? '' : 'p-input-icon-right';

        return (

            <Field name={this.props.fieldName}>
                {(fieldProps: FieldProps) => {

                    const meta = fieldProps.meta;
                    const errorText = meta.touched ? meta.error : '';
                    const tooltipTargetName = `${this.props.fieldName}-help`;
                    const showHelpIcon = this.props.help !== undefined;
                    const fieldClasses = classNames('inputfield', {
                        'w-full': this.props.expand ?? true,
                        'p-invalid': errorText !== undefined && errorText.length > 0
                    });

                    return (
                        <div className="field">

                            <label htmlFor={this.props.fieldName} className="block minput-label">
                                {this.props.label}
                            </label>

                            <div className="flex justify-content-start align-items-center">
                                <div className={`p-inputgroup ${iconPosition}`}>
                                    <i className={icon}/>
                                    {
                                        this.props.children(fieldProps, fieldClasses)
                                    }
                                </div>
                                {
                                    showHelpIcon &&
                                    <span className="ml-2">
                                        <MHelpIcon targetName={tooltipTargetName} tooltipContent={this.props.help!}/>
                                    </span>
                                }
                            </div>

                            <MErrorText id={this.props.fieldName} text={errorText}/>

                        </div>
                    );

                }}
            </Field>

        );

    }

}

export default MFormFieldControl;
